<template>
  <div class="sapDeliveryEdit">
    <el-dialog
        class="SapDeliveryEditDialog"
        :visible.sync="dialogVisible"
        title="发货通知"
        width="1200px"
        top="5vh">
      <el-button
          type="primary"
          style="margin-bottom: 5px"
          @click="$refs.sapNoticeForm.open(0,false,saleOrderInfo.deliveryPlace)">
        新建
      </el-button>
      <el-table
          v-loading="loading"
          row-key="pkId"
          :expand-row-keys="expands"
          :data="tableData"
          border
          @expand-change="rowExpand">
        <el-table-column align="center" width="120" show-overflow-tooltip label="SAP发货单号">
          <template slot-scope="scope">
            <span
                style="color: #2d8cf0; cursor: pointer"
                @click="$refs.sapNoticeForm.open(scope.row.billNo, 'preview')">
              {{scope.row.billNo}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
            prop="deliveryBillNo"
            show-overflow-tooltip
            align="center"
            width="120"
            label="发货单号"/>
        <el-table-column
            prop="creditStatus"
            align="center"
            width="120"
            label="信贷状态">
          <template slot-scope="scope">
            <span v-if="scope.row.creditStatus === 'B'">冻结</span>
            <span v-else>通过</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="salesOrderNo"
            show-overflow-tooltip
            align="center"
            width="120"
            label="销售订单编号"/>
        <el-table-column prop="customerName" show-overflow-tooltip align="left" label="客户名称"/>
        <el-table-column
            prop="customerContractNo"
            show-overflow-tooltip
            align="center"
            width="140"
            label="客户合同号"/>
        <el-table-column prop="deliveryDate" align="center" width="120" label="发货日期"/>
        <el-table-column prop="statusName" align="center" width="100" label="状态"/>
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button :disabled="scope.row.status !== 0" :loading="submitLoading" type="warning" @click="submitSapDelivery(scope.row)">
              提交
            </el-button>
            <el-button
                :disabled="scope.row.status !== 0"
                type="primary"
                @click="$refs.sapNoticeForm.open(scope.row.billNo)">
              编辑
            </el-button>
            <el-button :disabled="scope.row.status !== 0" type="danger" :loading="deleteLoading" @click="deleteHandle(scope.row.pkId)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
      </span>
      <sap-notice-form
          ref="sapNoticeForm"
          :sales-order-id="saleOrderInfo.pkId"
          @success="getData(saleOrderInfo.billNo)"/>
    </el-dialog>
  </div>
</template>

<script>
  import SapNoticeForm from "./SapNoticeForm";

  export default {
    components: {SapNoticeForm},
    data() {
      return {
        dialogVisible: false,
        submitLoading:false,
        deleteLoading:false,
        flag: "",
        tableData: [],
        saleOrderInfo: {},
        detailData: [],
        loading: false,
        expands: [],
        detailLoading: false,
      };
    },
    methods: {
      open(row) {
        this.saleOrderInfo = row;
        console.log(this.saleOrderInfo);
        if (row.property === "ZDQ") {
          this.flag = true;
        } else {
          this.flag = false;
        }
        this.dialogVisible = true;
        this.getData(row.billNo);
      },

      // 根据SAP订单号查询发货通知单列表
      getData(billNo) {
        this.loading = true;
        let params = {
          salesOrderNo: billNo,
        };
        this.$http
          .get("basic", "sapDeliveryBills/selectList", params)
          .then((res) => {
            if (res.success) {
              console.log(res.data);
              this.tableData = res.data;
              this.loading = false;
            } else {
              this.$message.error(res.message);
              this.loading = false;
            }
          })
          .catch(() => {
            this.loading = false;
          });
      },

      // 展开第一层获取扫描信息
      rowExpand(row, expandedRows) {
        this.detailLoading = true;
        if (expandedRows.length) {
          this.expands = [];
          if (row) {
            this.expands.push(row.pkId);
            let params = {
              billId: row.pkId,
            };
            this.$http
              .get("basic", "sapDeliveryBills/details", params)
              .then((res) => {
                // console.log(res);
                this.detailData = res;
                this.tableData = this.tableData.slice(0);
                this.detailLoading = false;
              })
              .catch(() => {
                this.detailLoading = false;
              });
          }
        } else {
          this.expands = [];
        }
      },

      // 删除发货单
      deleteHandle(pkId) {
        this.detailLoading=true;
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.get("basic", `sapDeliveryBills/del/${pkId}`).then(() => {
            this.$message.success("删除成功");
            this.expands = [];
            this.getData(this.saleOrderInfo.billNo);
            this.detailLoading=false;
          });
        });
      },

      // 提交发货单
      submitSapDelivery(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          if (row.status === 0) {
            let ids = [];
            ids.push(row.pkId);
            this.submitLoading=true;
            this.$http.post("basic", "sapDeliveryBills/submitShipment", ids).then((resp) => {
              if (resp.success){
                this.$message.success("提交成功");
                this.expands = [];
                this.getData(this.saleOrderInfo.billNo);
                this.submitLoading=false;
              }
            }).finally(()=>{
              this.submitLoading=false;
            });
          }
        });
      },
    },
  };
</script>

<style>
.sapDeliveryEdit .el-dialog .el-dialog__body {
  padding-top: 10px;
}
</style>
